export const loadLogin = (state, status) => {
  state.isLog = status;
};
export const loadDirectory = (state, directory) => {
  state.directory = directory;
};
export const loadPersonalContacts = (state, contacts) => {
  state.personalContacts = contacts;
};
export const loadRecords = (state, records) => {
  state.records = records;
};
export const loadCallRecords = (state, data) => {
  state.callRecords = data.cdrs;
  state.totalCallRecords = data.total;
};
export const setLoading = (state, loading) => {
  state.loading = loading;
};
export const setNoResults = (state, value) => {
  state.noResults = value;
};
export const loadVoiceMail = (state, data) => {
  state.personalVoiceMail = data.results;
  state.voiceMailTotalCount = data.count;
  state.voiceMailTotalPages = data.total_pages;
};
export const loadVoiceMailCount = (state, voiceMailCount) => {
  state.voiceMailCount = voiceMailCount;
};
export const loadConferences = (state, conferences) => {
  state.conferences = conferences;
};
export const loadUserSettingsRecords = (state, data) => {
  state.userSettings = data;
};
export const setMeetings = (state, meetings) => {
  state.meetings = meetings;
};
export const setCountMeetings = (state, count) => {
  state.meetingsCount = count;
};
export const setNewMeetings = (state, meetingUrl) => {
  state.meetingLink = meetingUrl;
};
export const showSnackbarMessage = (state, message) => {
  state.snackbarMessage = message;
  state.showSnackbar = true;
};
export const hideSnackbarMessage = (state) => {
  state.showSnackbar = false;
  state.snackbarMessage = "";
};
export const setVideoMeeting = (state, videosMeet) => {
  state.videosMeet = videosMeet;
};
export const setShowPreview = (state, show) => {
  state.previewView.show = show;
};
export const setLinkImg = (state, link) => {
  state.previewView.img = link;
};
export const setLink = (state, link) => {
  state.previewView.link = link;
};
export const setImgVideo = (state, type) => {
  state.previewView.type = type;
};

export const setShowDetailChat = (state, toggle) => {
  console.log("setShowDetailChat", toggle);
  console.log("state.state", state);
  state.detailChat.show = toggle;
};

export const setDetailtChatData = (state, data) => {
  state.detailChat.data = data;
};
export const setShowDetailChatJoin = (state, toggle) => {
  state.detailChatJoin.show = toggle;
};
export const setShowDetailChatFexIA = (state, toggle) => {
  state.detailChatFexIA.show = toggle;
};
export const setDetailChatDataFexIA = (state, data) => {
  state.detailChatFexIA.data = data;
};
export const setDetailtChatDataJoin = (state, data) => {
  state.detailChatJoin.data = data;
};
const eext = (name) => {
  if (name) {
    const parts = name.split(".");
    return parts.length > 1 ? parts.pop() : "Archivo";
  }
  return "Archivo";
};
const formatFileSize = (totalSize) => {
  if (totalSize < 1024 * 1024) {
    const kb = (totalSize / 1024).toFixed(2);
    return `${kb} KB`;
  } else if (totalSize < 1024 * 1024 * 1024) {
    const mb = (totalSize / (1024 * 1024)).toFixed(2);
    return `${mb} MB`;
  } else {
    const gb = (totalSize / (1024 * 1024 * 1024)).toFixed(2);
    return `${gb} GB`;
  }
};
// export const setDriveData = (state, data) => {
  // const files = data.files.map((file) => {
  //   const extension = eext(file.filename);
  //   return {
  //     ...file,
  //     extension,
  //     sizeText: formatFileSize(file.size),
  //   };
  // })
//   const folders = data.folders
//   let files = data.files
//   files = folders.concat(files)
//   if (data.crm) {
//     files.unshift({
//       name: 'CRM',
//       filepath: './CRM/',
//       last_modified: data.crm.last_modified,
//       size: formatFileSize(data.crm.size),
//       file_type: 'Carpeta',
//       protected: true,
//       selectable: false,
//       special: true,
//     })
//   }
//   if (data.shared && data.shared === true) {
//     files.unshift({
//       name: 'COMPARTIDO',
//       filepath: './SHARED/',
//       last_modified: '',
//       size: '',
//       file_type: 'Carpeta',
//       protected: true,
//       selectable: false,
//       special: true,
//     })
//   }
//   files.unshift({
//     name: 'CHATS',
//     filepath: './CHATS/',
//     last_modified: data.chats.last_modified,
//     size: formatFileSize(data.chats.size),
//     file_type: 'Carpeta',
//     protected: true,
//     selectable: false,
//     special: true,
//   })
//   files.unshift({
//     name: 'MIS GRABACIONES',
//     filepath: './MIS GRABACIONES/',
//     last_modified: data.records.last_modified,
//     size: formatFileSize(data.records.size),
//     file_type: 'Carpeta',
//     protected: true,
//     selectable: false,
//     special: true,
//   })
//   const parsedData = {
//     files,
//     filesCount: data.files_count,
//     totalSize: data.total_size,
//     loading: false,
//   };
//   state.drive = { ...parsedData };
// };

export const setFolderData = (state, data) => {
  const files = data.files.map((file) => {
    const extension = eext(file.filename);
    return {
      ...file,
      extension,
      sizeText: formatFileSize(file.size),
    };
  })
  const parsedData = {
    files,
    filesCount: data.files_count,
    totalSize: data.total_size,
    loading: false,
  }
  state.drive = { ...parsedData }
}

export const setFolderData2 = (state, data) => {
  const idFolder = data.idFolder
  data = data.data
  const files = data.results
  const parsedData = {
    files,
    filesCount: data.count,
    totalSize: 0,
    loading: false,
    indexFolder: idFolder
  }
  state.drive = { ...parsedData }
}

export const setFileFolder = (state, data) => {
  const filesA = data.results
  const folders = state.drive
  const files = folders.concat(filesA)
  const parsedData = {
    files,
    filesCount: data.count,
    totalSize: 0,
    loading: false,
  }
  state.drive = { ...parsedData }
}

export const setIndexFolder = (state, id) => {
  state.drive.indexFolder = id
}

export const addIndexFolder = (state, id) => {
  state.drive.arrayFolder.push(id)
}

export const backIndexFolder = (state, id) => {
  const arrayIndex = state.drive.arrayFolder
  const targetIndex = arrayIndex.indexOf(id)
  if (targetIndex !== -1) {
    arrayIndex.splice(targetIndex + 1)
  }
  state.drive.arrayFolder = arrayIndex
}


export const showSuccessModal = (state, { title, content }) => {
  state.msgModal.color = "green";
  state.msgModal.title = title;
  state.msgModal.content = content;
  state.msgModal.task = null;
  state.msgModal.confirmBtn = false;
  state.msgModal.show = true;
};
export const showErrorModal = (state, { title, content }) => {
  state.msgModal.color = "red";
  state.msgModal.title = title;
  state.msgModal.content = content;
  state.msgModal.task = null;
  state.msgModal.confirmBtn = false;
  state.msgModal.show = true;
};

export const toggleContactModal = (state, {toggle, option = false}) => {
  state.contactModal.show = toggle
  state.contactModal.hasNumber = option
}

export const showAskModal = (state, { title, content, task }) => {
  state.msgModal.loading = false;
  state.msgModal.color = "yellow-darken-1";
  state.msgModal.title = title;
  state.msgModal.content = content;
  state.msgModal.confirmBtn = true;
  state.msgModal.task = task;
  state.msgModal.show = true;
};
export const executeFunctionModal = (state) => {
  state.msgModal.loading = true;
  state.msgModal.task();
};
export const hideMsgModal = (state) => {
  state.msgModal.show = false;
};
export const updateState = (state, { key, keySearch, value }) => {
  console.log(
    "Entidad: ",
    key,
    "Llave busqueda: ",
    keySearch,
    "respuesta id: ",
    value.id,
    "Primer posicion: ",
    state[key][0][keySearch],
    state[key][0],
  );
  let index = state[key].findIndex((item) => item[keySearch] === value.id);
  console.log("INDEX: ", index);
  state[key][index].call_label = value.call_label;
  state[key][index].call_label_color = value.call_label_color;
};

export const setUserStorage = (state, {protected_folders, drive, count, size}) => {
  state.drive.fileCount = count
  state.drive.totalSize = size
  let tableRows = []
  for (const key in protected_folders) {
    if (key === 'shared') {
      const element = protected_folders[key]
      element['size'] = 0
      element['last_modified'] = ''
      element['protected'] = true
      element['name'] = 'COMPARTIDO CONMIGO'
      element['special'] = true
      tableRows.push(element)
    }else if (Object.prototype.hasOwnProperty.call(protected_folders, key)) {
      const element = protected_folders[key]
      key === 'records' ? element['name'] = 'mis grabaciones'.toUpperCase() : element['name'] = key.toUpperCase()
      element['protected'] = true
      element['special'] = true
      tableRows.push(element)
    }
  }
  tableRows = tableRows.concat(drive.folders, drive.files)
  state.drive.tableRows = tableRows
}
const DATE_SUBFOLDER_RE = /^\d{4}-\d{2}-\d{2}$/

const buildChatsRootRows = (subfolders, filesProps) => {
  // Username folders keep backend order (mtime desc — most recently active first)
  const usernameFolders = (subfolders || []).filter(name => !DATE_SUBFOLDER_RE.test(name))
  // Date folders sorted descending by name so most recent date appears first
  const dateFolders = (subfolders || [])
    .filter(name => DATE_SUBFOLDER_RE.test(name))
    .sort((a, b) => b.localeCompare(a))

  const rows = [...usernameFolders, ...dateFolders].map(name => ({
    name,
    file_type: 'Carpeta',
    size: null,
    last_modified: '',
    isChatSubfolder: true,
    selectable: false,
  }))

  // "Otros" only for files with truly empty subfolder (no directory assigned)
  const hasOrphaned = (filesProps || []).some(f => !f.subfolder)
  if (hasOrphaned) {
    rows.push({
      name: 'Otros',
      file_type: 'Carpeta',
      size: null,
      last_modified: '',
      isChatSubfolder: true,
      isChatLegacy: true,
      selectable: false,
    })
  }
  return rows
}

export const setUserProtectedFolder = (state, {size, file_count, files_props, folder, subfolders}) => {
  state.drive.currentDirectory = folder
  state.drive.protected = true
  state.drive.fileCount = file_count
  state.drive.totalSize = size
  if (folder === 'shared') {
    const tableRows = files_props.folders.concat(files_props.files)
    state.drive.tableRows = tableRows
  } else if (folder === 'chats') {
    state.drive.chatsAllFiles = files_props || []
    state.drive.chatsSubfolders = subfolders || []
    state.drive.chatsActiveSubfolder = null
    state.drive.tableRows = buildChatsRootRows(subfolders || [], files_props || [])
  } else {
    state.drive.tableRows = files_props
  }
}

export const setChatSubfolderView = (state, subfolderName) => {
  state.drive.chatsActiveSubfolder = subfolderName
  if (subfolderName === '__legacy__') {
    state.drive.tableRows = state.drive.chatsAllFiles.filter(f => !f.subfolder)
  } else {
    state.drive.tableRows = state.drive.chatsAllFiles.filter(f => f.subfolder === subfolderName)
  }
}

export const setDirectory = (state, id) => {
  state.drive.protected = false
  console.log(id);
  
  state.drive.currentDirectory = id
}

export const setFolder = (state, {file_count, size, folders, files}) => {
  state.drive.fileCount = file_count
  state.drive.totalSize = size
  let tableRows = []
  tableRows = tableRows.concat(folders, files)
  state.drive.tableRows = tableRows
}

export const addPath = (state, obj) => {
  state.drive.path.push(obj)
}

export const updatePath = (state, id) => {
  let pathArr = state.drive.path
  const index = pathArr.findIndex(obj => obj.id === id)
  if (index !== -1) {
    pathArr = pathArr.slice(0, index + 1)
  }
  state.drive.path = pathArr
}

export const updateContactExist = (state, exists) => {
  state.contactModal.contactExist = exists
}

export const newTranscription = (state, data) => {
  const recordIndex = state.records.dicc.records.findIndex(record => record.id === data.call_record_id); 
  if (recordIndex !== -1) {
    state.records.dicc.records[recordIndex].transcription = data.transcription;
  }
  state.recordTranscription = { ...data};
};

